import 'css-chunk:src/cms/header/header.module.scss';export default {
  "heading-xxl": "header-module__heading-xxl___rqbr0",
  "wrapper": "header-module__wrapper___mi3c1",
  "heading-xl": "header-module__heading-xl___SMh8K",
  "heading-lg": "header-module__heading-lg___vmJxm",
  "heading-md": "header-module__heading-md___5tmXD",
  "heading-sm": "header-module__heading-sm___F-RYK",
  "heading-xs": "header-module__heading-xs___Uaiiv",
  "body-one": "header-module__body-one___3a3hn",
  "body-two": "header-module__body-two___i2aOg",
  "body-three": "header-module__body-three___aIWZN",
  "body-four": "header-module__body-four___wyc8B",
  "overline-one": "header-module__overline-one___n4urL",
  "overline-two": "header-module__overline-two___mNhye",
  "overline-three": "header-module__overline-three___Yk3k9",
  "strong": "header-module__strong___Juk38",
  "em": "header-module__em___P49P-",
  "figcaption": "header-module__figcaption___nMqn9",
  "no-margin": "header-module__no-margin___kA54Y",
  "headerNavigation": "header-module__headerNavigation___GWCIp",
  "mainLinksWrapper": "header-module__mainLinksWrapper___K-T4u",
  "homeLink": "header-module__homeLink___kSEuk",
  "mainLinks": "header-module__mainLinks___0WyP9",
  "buttonLinks": "header-module__buttonLinks___0IdUj",
  "loading": "header-module__loading___Nyxzk",
  "mainMenu": "header-module__mainMenu___qk0g9",
  "signIn": "header-module__signIn___0XCc9",
  "newProject": "header-module__newProject___fedyC",
  "createAccount": "header-module__createAccount___WHNjj",
  "goToDashboard": "header-module__goToDashboard___m43fg",
  "iconButton": "header-module__iconButton___NWUnH",
  "helpButton": "header-module__helpButton___nHeOH",
  "hamburgerButton": "header-module__hamburgerButton___2pdBg",
  "menu": "header-module__menu___W4-10",
  "newProjectMenu": "header-module__newProjectMenu___wdAke",
  "description": "header-module__description___nzDSN",
  "accountLinks": "header-module__accountLinks___QoFXK",
  "helpMenu": "header-module__helpMenu___xtQBI",
  "hamburgerMenu": "header-module__hamburgerMenu___k-OrO",
  "hamburgerButtonWrapper": "header-module__hamburgerButtonWrapper___yoAmL",
  "hasDisplayLogic": "header-module__hasDisplayLogic___J-YPW"
};